import { lazy, Suspense, type ReactNode } from "react";
import { createHashRouter } from "react-router-dom";
import { Providers } from "../app/providers";
import { HubsShell } from "./HubsShell";
import { RouteLoading } from "./RouteLoading";

function wrap(node: ReactNode) {
  return <Suspense fallback={<RouteLoading />}>{node}</Suspense>;
}

const HomePage = lazy(() => import("../app/(hubs)/page"));
const EventsPage = lazy(() => import("../app/(hubs)/events/page"));
const FriendsPage = lazy(() => import("../app/(hubs)/friends/page"));
const LeaderboardPage = lazy(() => import("../app/(hubs)/leaderboard/page"));
const ProfilePage = lazy(() => import("../app/(hubs)/profile/page"));
const StorePage = lazy(() => import("../app/(hubs)/store/page"));
const LoginPage = lazy(() => import("../app/login/page"));
const WelcomePage = lazy(() => import("../app/welcome/page"));
const MatchmakingPage = lazy(() => import("../app/matchmaking/page"));
const PlayPage = lazy(() => import("../app/play/page"));

export const router = createHashRouter([
  {
    element: <Providers />,
    children: [
      {
        path: "/",
        element: <HubsShell />,
        children: [
          { index: true, element: wrap(<HomePage />) },
          { path: "events", element: wrap(<EventsPage />) },
          { path: "friends", element: wrap(<FriendsPage />) },
          { path: "leaderboard", element: wrap(<LeaderboardPage />) },
          { path: "profile", element: wrap(<ProfilePage />) },
          { path: "store", element: wrap(<StorePage />) },
        ],
      },
      { path: "/login", element: wrap(<LoginPage />) },
      { path: "/welcome", element: wrap(<WelcomePage />) },
      { path: "/matchmaking", element: wrap(<MatchmakingPage />) },
      { path: "/play", element: wrap(<PlayPage />) },
    ],
  },
]);
